import { default as PrimafloraLogoSvg } from './images/primaflora_logo.svg';
import { default as SearchIcon } from './images/search_icon.svg';
import { default as FacebookIcon } from './images/facebook-icon.svg';
import { default as InstagramIcon } from './images/instagram-icon.svg';
import { default as TelegramIcon } from './images/telegram-icon.svg';
import { default as ViberIcon } from './images/viber_icon.svg';
import { default as YoutubeIcon } from './images/youtube-icon.svg';
import { default as CategoryImage } from './images/category-image.png';
import { default as LikeIcon } from './images/like.svg';
import { default as LikeRedIcon } from './images/like-red.svg';
import { default as CommentIcon } from './images/comment-icon.svg';
import { default as CrossIcon } from './images/cross_icon.svg';
import { default as CrossWhiteIcon } from './images/cross_icon_white.svg';
import { default as CartIconMob } from './images/cart-icon-mob.svg';
import { default as LinedLikeIconMob } from './images/like-lined-icon-mob.svg';
import { default as UserIconMob } from './images/user-icon-mob.svg';
import { default as DeliveryIconMob } from './images/delivery-icon-mob.svg';
import { default as ArrowListDownIcon } from './images/arrow-list-down.svg';
import { default as ArrowListDownIconWhite } from './images/arrow-list-down-white.svg';
import { default as AdminIcon } from './images/admin-icon.svg';
import { default as AddCommentIcon } from './images/add-comment-icon.svg';
import { default as FolderIcon } from './images/folder-icon.svg';
import { default as AddNoteIcon } from './images/add-note-icon.svg';
import { default as LightbublIcon } from './images/lightbubl.svg';
import { default as TrashIcon } from './images/trash.svg';
import { default as CheckmarkIcon } from './images/checkmark.svg';
import { default as OrderIcon } from './images/order-icon.svg';
import CheckMarkDark from './images/check-mark-dark.png';
import CheckMarkGreen from './images/check-mark-green.png';
import RusFlag from './images/russia.png';
import UkrFlag from './images/ukraine.png';
import SliderImage from './images/sliderImage.jpg';

export const Images = {
    PrimafloraLogoSvg,
    SearchIcon,
    FacebookIcon,
    InstagramIcon,
    TelegramIcon,
    ViberIcon,
    YoutubeIcon,
    CategoryImage,
    LikeIcon,
    LikeRedIcon,
    CommentIcon,
    CrossIcon,
    CrossWhiteIcon,
    CartIconMob,
    LinedLikeIconMob,
    UserIconMob,
    DeliveryIconMob,
    ArrowListDownIcon,
    CheckMarkDark,
    CheckMarkGreen,
    RusFlag,
    UkrFlag,
    SliderImage,
    ArrowListDownIconWhite,
    TrashIcon,
    AdminIcon,
    AddCommentIcon,
    FolderIcon,
    AddNoteIcon,
    LightbublIcon,
    CheckmarkIcon,
    OrderIcon
};
